"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _utils = require("../../helpers/utils");

var _containers = require("../containers");

var _spacers = require("../spacers");

var _FilledStar = _interopRequireDefault(require("../../svg/FilledStar"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _templateObject10() {
  var data = _taggedTemplateLiteralLoose(["\n  padding-right: 0.5rem;\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: 1.4rem;\n  color: #626262;\n  letter-spacing: 0.1px;\n  line-height: 2.4rem;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  @media (min-width: 768px) {\n    font-weight: 700;\n    font-size: 1.2rem;\n  }\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n  color: #888;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n  color: #888;\n  font-size: 1.3rem;\n  padding: .5rem 0rem;\n  text-transform: uppercase;\n  letter-spacing: .08rem;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n  font-weight: 600;\n  font-size: 2rem;\n  padding: 1rem 0rem;\n  @media (max-width: 767px) {\n    font-size: 1.5rem;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  font-weight: 600;\n  font-size: 2.2rem;\n  padding: .5rem 0rem;\n  @media (max-width: 767px) {\n    font-size: 1.7rem;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  margin: 0rem;\n  cursor: pointer;\n  width: 35%;\n\n  @media (max-width: 767px) {\n    width: 55%;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  ", ";\n  display: flex;\n  margin: 0;\n  height: 100%;\n  width: 100%;\n  object-fit: contain;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var CardImage = _styledComponents["default"].img(_templateObject(), function (props) {
  return props.height ? "height: " + props.height + ";" : '';
}, function (props) {
  return props.width ? "width: " + props.width + ";" : '';
});

var ImageContainer = (0, _styledComponents["default"])(_containers.Container)(_templateObject2());
var CommercialName = (0, _styledComponents["default"])(_containers.FlexRow)(_templateObject3());
var Price = (0, _styledComponents["default"])(_containers.FlexRow)(_templateObject4());
var DeptNameWrapper = (0, _styledComponents["default"])(_containers.FlexRow)(_templateObject5());
var SizeColorWrapper = (0, _styledComponents["default"])(_containers.FlexRow)(_templateObject6());
var SizeColorRow = (0, _styledComponents["default"])(_containers.FlexRow)(_templateObject7());

var ReviewContainer = _styledComponents["default"].div(_templateObject8());

var Rating = _styledComponents["default"].div(_templateObject9());

var RatingContent = _styledComponents["default"].div(_templateObject10());

var Reviews = function Reviews(_ref) {
  var reviews = _ref.reviews,
      rating = _ref.rating;
  var totalRating = rating === "NaN" ? 0 : rating;
  return /*#__PURE__*/_react["default"].createElement(ReviewContainer, null, /*#__PURE__*/_react["default"].createElement(Rating, null, /*#__PURE__*/_react["default"].createElement(RatingContent, null, /*#__PURE__*/_react["default"].createElement(_FilledStar["default"], {
    color: "#FFC600",
    width: 11,
    height: 11
  })), /*#__PURE__*/_react["default"].createElement(RatingContent, null, totalRating || 0), " ", /*#__PURE__*/_react["default"].createElement(RatingContent, null, "(", reviews, " review", reviews !== 1 ? "s" : "", ")")));
};

var ProductWithReviewCard = function ProductWithReviewCard(_ref2) {
  var onClickImage = _ref2.onClickImage,
      productId = _ref2.productId,
      image = _ref2.image,
      departmentName = _ref2.departmentName,
      commercialName = _ref2.commercialName,
      reviews = _ref2.reviews,
      rating = _ref2.rating,
      amount = _ref2.amount,
      size = _ref2.size,
      color = _ref2.color; //product with review indicator

  return /*#__PURE__*/_react["default"].createElement(_containers.FlexRow, null, /*#__PURE__*/_react["default"].createElement(ImageContainer, {
    boxSizing: "border-box",
    onClick: onClickImage
  }, image && /*#__PURE__*/_react["default"].createElement(CardImage, {
    src: image
  })), /*#__PURE__*/_react["default"].createElement(_containers.FlexColumn, {
    justifyContent: "space-around",
    padding: "0rem 2rem"
  }, /*#__PURE__*/_react["default"].createElement(_containers.FlexColumn, null, /*#__PURE__*/_react["default"].createElement(DeptNameWrapper, {
    fontWeight: 600
  }, departmentName), /*#__PURE__*/_react["default"].createElement(CommercialName, null, commercialName), /*#__PURE__*/_react["default"].createElement(Reviews, {
    reviews: reviews,
    rating: rating
  })), /*#__PURE__*/_react["default"].createElement(Price, null, "\u20B1 ", (0, _utils.getFormattedCurrency)(amount)), size || color ? /*#__PURE__*/_react["default"].createElement(SizeColorWrapper, {
    padding: "1rem 0rem"
  }, size ? /*#__PURE__*/_react["default"].createElement(_containers.FlexRow, {
    justifyContent: "center"
  }, /*#__PURE__*/_react["default"].createElement(SizeColorRow, {
    fontSize: "1.3rem",
    fontWeight: 600
  }, "Size:"), /*#__PURE__*/_react["default"].createElement(_spacers.VerticalSpacer, {
    width: '1rem'
  }), /*#__PURE__*/_react["default"].createElement(_containers.FlexRow, {
    fontSize: "1.3rem",
    fontWeight: 600
  }, size), /*#__PURE__*/_react["default"].createElement(_spacers.VerticalSpacer, {
    width: '2rem'
  })) : null, color ? /*#__PURE__*/_react["default"].createElement(_containers.FlexRow, {
    justifyContent: "center"
  }, /*#__PURE__*/_react["default"].createElement(SizeColorRow, {
    fontSize: "1.3rem",
    fontWeight: 600
  }, "Colour: "), /*#__PURE__*/_react["default"].createElement(_spacers.VerticalSpacer, {
    width: '1rem'
  }), /*#__PURE__*/_react["default"].createElement(_containers.FlexRow, {
    fontSize: "1.3rem",
    fontWeight: 600
  }, color)) : null) : null));
};

var _default = ProductWithReviewCard;
exports["default"] = _default;
module.exports = exports["default"];